<template>
  <div
    class="produit-usage_item"
    :class="{ 'produit-usage_item--open': isActive }"
  >
    <div class="produit-usage_head clickable" @click="isActive = !isActive">
      <button class="accordion">
        <span class="chevron">&rsaquo;</span>
      </button>
      <div class="flex flex-wrap items-center">
        <status-chip :status="item.status"></status-chip>
        <div class="">{{ item.code }} {{ item.name }}</div>
        <div class="text-sm text-gris ml-3">
          <div v-if="item.approval_date_start && item.approval_date_end">
            (Autorisé du
            {{ item.approval_date_start }}
            au
            {{ item.approval_date_end }})
          </div>
          <div v-else-if="item.approval_date_end">
            (Autorisé jusqu'au {{ item.approval_date_end }})
          </div>
        </div>
      </div>
    </div>

    <div
      class="produit-usage_main accordion_item"
      :class="{ 'accordion_item--active': isActive }"
    >
      <div v-for="use in item.uses" :key="use.id">
        <div class="my-5">
          <use-item :product="product" :item="use"></use-item>
        </div>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import StatusChip from '@/components/StatusChip'
import UseItem from './UseItem.vue'

export default {
  name: 'UseAccordionItem',
  components: { StatusChip, UseItem },

  props: {
    item: Object,
    product: Object
  },

  data () {
    return {
      isActive: false
    }
  }
}
</script>
